import useSessionStorage from './useSessionStorage';

function useRedirectUrl() {
    const [url, setUrl] = useSessionStorage('redirectUrl');
    const params = new URLSearchParams(window.location.search);
    const newUrl = params.has('plaidRedirectUrl') ? params.get('plaidRedirectUrl') : params.get('redirectUrl');
    if (newUrl && newUrl !== url) {
        setUrl(newUrl);
        return newUrl;
    }
    return url;
};

export default useRedirectUrl;